/**
 * Home's main chart: the range's trend card (plays, watch time or viewers per day, the previous
 * period faint behind it, table and CSV) at a dashboard's height. A placeholder of the same height
 * while the summary loads; the previous answer dimmed while a new range loads.
 */

import { SkeletonCard } from "@web-ui/components/Skeleton";
import { TrendCard } from "../components/trend-card";
import type { ReportScope } from "../scope";
import type { Kpis } from "../use-kpis";

const CHART_HEIGHT = 280;

export function HomeTrend({ scope, kpis, firstStep }: {
  scope: ReportScope;
  kpis: Kpis;
  /** What to do when nobody has watched yet (publish first, when nothing is live). */
  firstStep?: { label: string; href: string };
}) {
  const s = kpis.summary.data;
  if (!s && kpis.summary.failed) return <section className="card px-card-inset py-4 text-body-2 text-t-secondary" aria-label="Over time">Viewing numbers are not available right now.</section>;
  if (!s) return <SkeletonCard label="Loading the chart" rows={11} className="min-h-118" />;
  const stale = kpis.summary.stale || kpis.previous.stale;
  return (
    <div className={`flex flex-col transition-opacity [&>*]:grow ${stale ? "opacity-60" : ""}`} aria-busy={stale || undefined}>
      <TrendCard scope={scope} current={s.series} before={kpis.previous.data?.series ?? null} what="home" height={CHART_HEIGHT}
        empty={kpis.empty || s.totals.plays === 0} emptyAction={firstStep} />
    </div>
  );
}
